import { render, staticRenderFns } from "./signprize.vue?vue&type=template&id=133f6528&scoped=true&"
import script from "./signprize.vue?vue&type=script&lang=js&"
export * from "./signprize.vue?vue&type=script&lang=js&"
import style0 from "./signprize.vue?vue&type=style&index=0&id=133f6528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f6528",
  null
  
)

export default component.exports